import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { ProjectSource } from '../../auth/lib/auth.types'
import { useSelectedProject } from '../../main/hooks/useSelectedProject'
import { FinanceService } from '../lib/finance.service'

export const FINANCE_BALANCE_QUERY_KEY = 'finance-balance'

export const useFinanceBalance = () => {
  const { selectedProject } = useSelectedProject()

  const { status, data, error, isLoading, isFetching, refetch, isError } =
    useQuery({
      queryKey: [FINANCE_BALANCE_QUERY_KEY, selectedProject?.bc_guid],
      queryFn: () =>
        FinanceService.getFinanceBalance(selectedProject?.bc_guid ?? ''),
      enabled: selectedProject?.src === ProjectSource.BU,
      placeholderData: keepPreviousData
    })

  return {
    data,
    error,
    isLoading,
    isFetching,
    status,
    refetch,
    isError
  }
}
